import { useEffect, useState, type ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { fetchAuthSession } from "aws-amplify/auth";
import { Box, CircularProgress } from "@mui/material";

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const [status, setStatus] = useState<"loading" | "authed" | "unauthed">("loading");

  useEffect(() => {
    fetchAuthSession()
      .then((session) => {
        setStatus(session.tokens?.idToken ? "authed" : "unauthed");
      })
      .catch(() => setStatus("unauthed"));
  }, []);

  if (status === "loading") {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }
  if (status === "unauthed") return <Navigate to="/auth" replace />;
  return <>{children}</>;
}
